// @generated by protoc-gen-es v2.2.0 with parameter "target=ts"
// @generated from file nike/clickstream/ux/commerce/gift_card/gift_card_center/v1/item_clicked.proto (package nike.clickstream.ux.commerce.gift_card.gift_card_center.v1, syntax proto3)
/* eslint-disable */
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_buf_validate_validate } from "../../../../../../../buf/validate/validate_pb";
/**
 * Describes the file nike/clickstream/ux/commerce/gift_card/gift_card_center/v1/item_clicked.proto.
 */
export const file_nike_clickstream_ux_commerce_gift_card_gift_card_center_v1_item_clicked = /*@__PURE__*/ fileDesc("Ck1uaWtlL2NsaWNrc3RyZWFtL3V4L2NvbW1lcmNlL2dpZnRfY2FyZC9naWZ0X2NhcmRfY2VudGVyL3YxL2l0ZW1fY2xpY2tlZC5wcm90bxI6bmlrZS5jbGlja3N0cmVhbS51eC5jb21tZXJjZS5naWZ0X2NhcmQuZ2lmdF9jYXJkX2NlbnRlci52MSKrAQoLSXRlbUNsaWNrZWQSaAoJaXRlbV9uYW1lGAEgASgOMkkubmlrZS5jbGlja3N0cmVhbS51eC5jb21tZXJjZS5naWZ0X2NhcmQuZ2lmdF9jYXJkX2NlbnRlci52MS5DbGlja2FibGVJdGVtQgq6SAeCAQQQASAAEiEKDGVycm9yX3N0YXR1cxgCIAEoCEIGukgDyAEBSACIAQFCDwoNX2Vycm9yX3N0YXR1cyrMAQoNQ2xpY2thYmxlSXRlbRIeChpDTElDS0FCTEVfSVRFTV9VTlNQRUNJRklFRBAAEhoKFkNMSUNLQUJMRV9JVEVNX0JVWV9OT1cQARIcChhDTElDS0FCTEVfSVRFTV9DQUxMX05JS0UQAhIcChhDTElDS0FCTEVfSVRFTV9NWV9XQUxMRVQQAxIgChxDTElDS0FCTEVfSVRFTV9DVVNUT01fQU1PVU5UEAQSIQodQ0xJQ0tBQkxFX0lURU1fQ09VUE9OX0NMQUlNRUQQBULXAgo+Y29tLm5pa2UuY2xpY2tzdHJlYW0udXguY29tbWVyY2UuZ2lmdF9jYXJkLmdpZnRfY2FyZF9jZW50ZXIudjFCEEl0ZW1DbGlja2VkUHJvdG9QAaICBk5DVUNHR6oCN05pa2UuQ2xpY2tzdHJlYW0uVXguQ29tbWVyY2UuR2lmdENhcmQuR2lmdENhcmRDZW50ZXIuVjHKAjdOaWtlXENsaWNrc3RyZWFtXFV4XENvbW1lcmNlXEdpZnRDYXJkXEdpZnRDYXJkQ2VudGVyXFYx4gJDTmlrZVxDbGlja3N0cmVhbVxVeFxDb21tZXJjZVxHaWZ0Q2FyZFxHaWZ0Q2FyZENlbnRlclxWMVxHUEJNZXRhZGF0YeoCPU5pa2U6OkNsaWNrc3RyZWFtOjpVeDo6Q29tbWVyY2U6OkdpZnRDYXJkOjpHaWZ0Q2FyZENlbnRlcjo6VjFiBnByb3RvMw", [file_buf_validate_validate]);
/**
 * Describes the message nike.clickstream.ux.commerce.gift_card.gift_card_center.v1.ItemClicked.
 * Use `create(ItemClickedSchema)` to create a new message.
 */
export const ItemClickedSchema = /*@__PURE__*/ messageDesc(file_nike_clickstream_ux_commerce_gift_card_gift_card_center_v1_item_clicked, 0);
/**
 * Represents the clickable items on gift card center page.
 *
 * @generated from enum nike.clickstream.ux.commerce.gift_card.gift_card_center.v1.ClickableItem
 */
export var ClickableItem;
(function (ClickableItem) {
    /**
     * @generated from enum value: CLICKABLE_ITEM_UNSPECIFIED = 0;
     */
    ClickableItem[ClickableItem["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: CLICKABLE_ITEM_BUY_NOW = 1;
     */
    ClickableItem[ClickableItem["BUY_NOW"] = 1] = "BUY_NOW";
    /**
     * @generated from enum value: CLICKABLE_ITEM_CALL_NIKE = 2;
     */
    ClickableItem[ClickableItem["CALL_NIKE"] = 2] = "CALL_NIKE";
    /**
     * @generated from enum value: CLICKABLE_ITEM_MY_WALLET = 3;
     */
    ClickableItem[ClickableItem["MY_WALLET"] = 3] = "MY_WALLET";
    /**
     * @generated from enum value: CLICKABLE_ITEM_CUSTOM_AMOUNT = 4;
     */
    ClickableItem[ClickableItem["CUSTOM_AMOUNT"] = 4] = "CUSTOM_AMOUNT";
    /**
     * @generated from enum value: CLICKABLE_ITEM_COUPON_CLAIMED = 5;
     */
    ClickableItem[ClickableItem["COUPON_CLAIMED"] = 5] = "COUPON_CLAIMED";
})(ClickableItem || (ClickableItem = {}));
/**
 * Describes the enum nike.clickstream.ux.commerce.gift_card.gift_card_center.v1.ClickableItem.
 */
export const ClickableItemSchema = /*@__PURE__*/ enumDesc(file_nike_clickstream_ux_commerce_gift_card_gift_card_center_v1_item_clicked, 0);
